// Page2.js - Roof Analysis Loading
'use strict';

import { logger, FIELDS } from '../utils/logger.js';
import { API_ENDPOINTS } from '../config.js';

export default class Page2 {
    constructor(widget) {
      this.widget = widget;
      this.shadowRoot = widget.shadowRoot;
      this.config = widget.config;

      // Page-specific properties
      this.coordinates = null;
    }

    render() {
      return `
        <!-- Page 2: Analysis Loading -->
        <div class="page" id="page-2" style="display: block;">
          <!-- Progress Section -->
          <div class="analysis-progress-section">
            <div class="progress-header">
              <span class="progress-title">Analysis Progress</span>
              <span class="progress-percentage" id="ai-progress-percent">0%</span>
            </div>
            <div class="progress-bar-container">
              <div class="progress-bar" id="ai-progress-bar" style="width: 0%"></div>
            </div>
          </div>

          <!-- Process Steps -->
          <div class="analysis-process-steps">
            <div class="analysis-step-item" id="ai-step-roof-outline">
              <div class="step-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path>
                </svg>
              </div>
              <div class="step-content">
                <div class="step-title">Detecting Roof Outline</div>
                <div class="step-time">~15 seconds</div>
              </div>
            </div>

            <div class="analysis-step-item" id="ai-step-detecting-faces">
              <div class="step-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                </svg>
              </div>
              <div class="step-content">
                <div class="step-title">Detecting Roof Faces</div>
                <div class="step-time">~10 seconds</div>
              </div>
            </div>

            <div class="analysis-step-item" id="ai-step-segmenting">
              <div class="step-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
              </div>
              <div class="step-content">
                <div class="step-title">Segmenting Roof Sections</div>
                <div class="step-time">~15 seconds</div>
              </div>
            </div>

            <div class="analysis-step-item" id="ai-step-uploading">
              <div class="step-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                </svg>
              </div>
              <div class="step-content">
                <div class="step-title">Finalizing Analysis</div>
                <div class="step-time">~10 seconds</div>
              </div>
            </div>
          </div>

          <!-- Hidden coordinate display for functionality -->
          <div id="selected-coordinates" style="display: none;"></div>
        </div>

        <style>
          /* Page 2 Styles */
          #page-2 {
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 20px 0;
          }

          /* Progress Section */
          .analysis-progress-section {
            padding: 0 20px;
          }

          .progress-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
          }

          .progress-title {
            font-size: 14px;
            color: #6b7280;
            font-weight: 500;
          }

          .progress-percentage {
            font-size: 24px;
            font-weight: 700;
            color: #3b82f6;
          }

          .progress-bar-container {
            width: 100%;
            height: 8px;
            background: #e5e7eb;
            border-radius: 100px;
            overflow: hidden;
          }

          .progress-bar {
            height: 100%;
            background: linear-gradient(90deg, #3b82f6 0%, #60a5fa 100%);
            border-radius: 100px;
            transition: width 0.5s ease;
            box-shadow: 0 0 10px rgba(59, 130, 246, 0.3);
          }

          /* Process Steps */
          .analysis-process-steps {
            padding: 0 20px;
          }

          .analysis-step-item {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 16px 0;
            border-bottom: 1px solid #e5e7eb;
          }

          .analysis-step-item:last-child {
            border-bottom: none;
          }

          .step-icon {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f3f4f6;
            border: 2px solid #e5e7eb;
            flex-shrink: 0;
            transition: all 0.3s ease;
          }

          .analysis-step-item.active .step-icon {
            background: rgba(59, 130, 246, 0.1);
            border-color: #3b82f6;
            animation: pulse-ring 2s ease-in-out infinite;
          }

          @keyframes pulse-ring {
            0% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4); }
            70% { box-shadow: 0 0 0 10px rgba(59, 130, 246, 0); }
            100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0); }
          }

          .analysis-step-item.completed .step-icon {
            background: #3b82f6;
            border-color: #3b82f6;
          }

          .step-icon svg {
            width: 20px;
            height: 20px;
            stroke: #6b7280;
            transition: all 0.3s ease;
          }

          .analysis-step-item.active .step-icon svg {
            stroke: #3b82f6;
            animation: rotate 2s linear infinite;
          }

          @keyframes rotate {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .analysis-step-item.completed .step-icon svg {
            stroke: white;
          }

          .step-content {
            flex: 1;
          }

          .step-title {
            font-size: 15px;
            font-weight: 500;
            color: #111827;
            margin-bottom: 4px;
          }

          .step-time {
            font-size: 13px;
            color: #6b7280;
          }
        </style>
      `;
    }

    onMount(data = {}) {
      // Initialize progress UI
      this.updateProgress(0);

      // Try to get coordinates from data parameter first, then from session
      if (data && data.coordinates) {
        this.coordinates = data.coordinates;
      } else {
        // Retrieve from session data if not in parameter
        const pinLocation = this.widget.getSessionData('pin_location');
        if (pinLocation) {
          this.coordinates = { lat: pinLocation.lat, lng: pinLocation.lng };
        }
      }

      // Display coordinates if available
      if (this.coordinates) {
        const coordsDisplay = this.shadowRoot.querySelector('#selected-coordinates');
        if (coordsDisplay) {
          coordsDisplay.textContent = `Lat: ${this.coordinates.lat}, Lng: ${this.coordinates.lng}`;
        }

        logger.info({
          [FIELDS.OPERATION]: 'onMount',
          [FIELDS.PAGE_NUMBER]: 2,
          [FIELDS.MESSAGE]: 'Page 2 mounted with coordinates',
          coordinates: this.coordinates
        });

        // Start analysis automatically
        this.startAnalysis();
      } else {
        logger.error({
          [FIELDS.OPERATION]: 'onMount',
          [FIELDS.PAGE_NUMBER]: 2,
          [FIELDS.REASON]: 'missing_coordinates'
        }, 'No coordinates available from data parameter or session');
      }
    }

    onUnmount() {
      logger.info({
        [FIELDS.OPERATION]: 'onUnmount',
        [FIELDS.PAGE_NUMBER]: 2,
        [FIELDS.MESSAGE]: 'Page 2 unmounting'
      });
    }

    /**
     * Update progress bar and percentage
     * @param {number} percentage - Progress from 0-100
     */
    updateProgress(percentage) {
      const progressBar = this.shadowRoot.querySelector('#ai-progress-bar');
      const progressPercent = this.shadowRoot.querySelector('#ai-progress-percent');

      if (progressBar) {
        progressBar.style.width = `${percentage}%`;
      }

      if (progressPercent) {
        progressPercent.textContent = `${Math.round(percentage)}%`;
      }
    }

    /**
     * Update step status (active, completed, pending)
     * @param {string} stepId - ID of the step element
     * @param {string} status - 'active', 'completed', or 'pending'
     */
    updateStepStatus(stepId, status) {
      const step = this.shadowRoot.querySelector(`#${stepId}`);
      if (!step) return;

      // Remove all status classes
      step.classList.remove('active', 'completed', 'pending');

      // Add new status class
      if (status === 'active' || status === 'completed') {
        step.classList.add(status);
      }

      logger.debug({
        [FIELDS.OPERATION]: 'updateStepStatus',
        [FIELDS.PAGE_NUMBER]: 2,
        stepId: stepId,
        status: status
      });
    }

    /**
     * Start the analysis process
     */
    async startAnalysis() {
      if (!this.coordinates) {
        logger.error({
          [FIELDS.OPERATION]: 'startAnalysis',
          [FIELDS.PAGE_NUMBER]: 2,
          [FIELDS.REASON]: 'missing_coordinates'
        }, 'Cannot start analysis without coordinates');
        return;
      }

      try {
        logger.info({
          [FIELDS.OPERATION]: 'startAnalysis',
          [FIELDS.PAGE_NUMBER]: 2,
          [FIELDS.MESSAGE]: 'Starting roof analysis',
          coordinates: this.coordinates
        });

        // Step 1: Initialize - Fetch building info
        this.updateStepStatus('ai-step-roof-outline', 'active');
        this.updateProgress(10);

        const buildingInfo = await this.fetchBuildingInfo();

        if (!buildingInfo) {
          throw new Error('Failed to fetch building information');
        }

        // Step 2: Start scan job
        this.updateProgress(20);
        const scanResponse = await this.callScanAPI(buildingInfo);

        // Step 3: Poll for results - progress updates happen in pollForResults based on data.job.status
        const results = await this.pollForResults(scanResponse);

        // Step 4: Complete
        this.updateStepStatus('ai-step-segmenting', 'completed');
        this.updateStepStatus('ai-step-uploading', 'completed');
        this.updateProgress(100);

        // Navigate to results page
        setTimeout(() => {
          this.widget.showPage(3, { results: results });
        }, 500);

      } catch (error) {
        logger.error({
          [FIELDS.OPERATION]: 'startAnalysis',
          [FIELDS.PAGE_NUMBER]: 2,
          [FIELDS.REASON]: error.message
        }, 'Analysis failed', error);

        // Show error state
        this.showError(error.message);
      }
    }

    /**
     * Fetch building information
     */
    async fetchBuildingInfo() {
      const url = `${this.config.serverUrl}${API_ENDPOINTS.GET_BUILDING_INFO}`;

      logger.info({
        [FIELDS.OPERATION]: 'fetchBuildingInfo',
        [FIELDS.PAGE_NUMBER]: 2,
        [FIELDS.MESSAGE]: 'Fetching building info',
        coordinates: this.coordinates
      });

      const response = await window.RoofScannerAPI.fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          pinLatitude: this.coordinates.lat,
          pinLongitude: this.coordinates.lng
        })
      });

      if (!response.ok) {
        throw new Error(`Building info API failed: ${response.statusText}`);
      }

      const data = await response.json();

      // Store building info in session
      if (data.buildingInfo) {
        this.widget.setSessionData('buildingInfo', {
          ...data.buildingInfo,
          retrievedAt: new Date().toISOString()
        });
      }

      logger.info({
        [FIELDS.OPERATION]: 'fetchBuildingInfo',
        [FIELDS.PAGE_NUMBER]: 2,
        [FIELDS.MESSAGE]: 'Building info received',
        buildingId: data.buildingInfo?.name
      });

      return data.buildingInfo;
    }

    /**
     * Call the scan API to initiate roof analysis
     */
    async callScanAPI(buildingInfo) {
      const url = `${this.config.serverUrl}${API_ENDPOINTS.SCAN_ROOF}`;

      logger.info({
        [FIELDS.OPERATION]: 'callScanAPI',
        [FIELDS.PAGE_NUMBER]: 2,
        [FIELDS.MESSAGE]: 'Calling scan API',
        url: url
      });

      const response = await window.RoofScannerAPI.fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          buildingId: buildingInfo.name,
          pinLatitude: this.coordinates.lat,
          pinLongitude: this.coordinates.lng,
          buildingCenter: buildingInfo.center,
          boundingBox: buildingInfo.boundingBox
        })
      });

      if (!response.ok) {
        throw new Error(`Scan API failed: ${response.statusText}`);
      }

      const data = await response.json();

      logger.info({
        [FIELDS.OPERATION]: 'callScanAPI',
        [FIELDS.PAGE_NUMBER]: 2,
        [FIELDS.MESSAGE]: 'Scan API response received',
        jobId: data.jobId
      });

      return data;
    }

    /**
     * Poll for analysis results using long-polling
     */
    async pollForResults(scanResponse) {
      const jobId = scanResponse.jobId;
      let expectedStatus = 'pending';

      logger.info({
        [FIELDS.OPERATION]: 'pollForResults',
        [FIELDS.PAGE_NUMBER]: 2,
        [FIELDS.MESSAGE]: 'Starting long-polling for results',
        jobId: jobId
      });

      while (true) {
        try {
          const url = `${this.config.serverUrl}/api/v1/roof-scanner/job/${jobId}/wait?expectedStatus=${expectedStatus}`;
          const response = await window.RoofScannerAPI.fetch(url, {
            method: 'GET'
          });

          if (!response.ok) {
            logger.warn({
              [FIELDS.OPERATION]: 'pollForResults',
              [FIELDS.PAGE_NUMBER]: 2,
              [FIELDS.REASON]: 'non_200_response',
              status: response.status
            }, `Long-poll returned ${response.status}`);
            await new Promise(resolve => setTimeout(resolve, 2000));
            continue;
          }

          const data = await response.json();

          if (!data.success || !data.job) {
            logger.warn({
              [FIELDS.OPERATION]: 'pollForResults',
              [FIELDS.PAGE_NUMBER]: 2,
              [FIELDS.REASON]: 'invalid_response'
            }, 'Invalid job status response');
            await new Promise(resolve => setTimeout(resolve, 2000));
            continue;
          }

          logger.debug({
            [FIELDS.OPERATION]: 'pollForResults',
            [FIELDS.PAGE_NUMBER]: 2,
            jobStatus: data.job.status
          }, `Job status changed to: ${data.job.status}`);

          // Update UI based on current status
          this.updateUIFromStatus(data.job.status);

          // Handle completion
          if (data.job.status === 'completed') {
            logger.info({
              [FIELDS.OPERATION]: 'pollForResults',
              [FIELDS.PAGE_NUMBER]: 2,
              [FIELDS.MESSAGE]: 'Results ready',
              jobId: jobId
            });

            // Store complete job data in session for Page 3
            this.widget.setSessionData('roofScanJob', {
              jobId: jobId,
              jobData: data.job
            });

            return data.job;
          }

          // Handle failure
          if (data.job.status === 'failed') {
            throw new Error('Roof scan job failed');
          }

          // Update expected status for next long-poll
          expectedStatus = data.job.status;

        } catch (error) {
          logger.error({
            [FIELDS.OPERATION]: 'pollForResults',
            [FIELDS.PAGE_NUMBER]: 2,
            [FIELDS.REASON]: 'poll_error',
            error: error.message
          }, 'Polling error', error);
          throw error;
        }
      }
    }

    /**
     * Update UI based on job status
     */
    updateUIFromStatus(status) {
      const statusToProgress = {
        'pending': { progress: 10, activeStep: 'ai-step-roof-outline' },
        'processing-roof-outline': { progress: 25, activeStep: 'ai-step-roof-outline' },
        'processing-detecting-faces': { progress: 50, activeStep: 'ai-step-detecting-faces' },
        'processing-segmenting': { progress: 75, activeStep: 'ai-step-segmenting' },
        'processing-uploading': { progress: 90, activeStep: 'ai-step-uploading' },
        'completed': { progress: 100, activeStep: null }
      };

      const currentStatus = statusToProgress[status];
      if (currentStatus) {
        this.updateProgress(currentStatus.progress);

        // Update step indicators
        const steps = ['ai-step-roof-outline', 'ai-step-detecting-faces', 'ai-step-segmenting', 'ai-step-uploading'];
        const activeIndex = steps.indexOf(currentStatus.activeStep);

        steps.forEach((stepId, index) => {
          if (index < activeIndex) {
            this.updateStepStatus(stepId, 'completed');
          } else if (index === activeIndex) {
            this.updateStepStatus(stepId, 'active');
          }
        });
      }
    }

    /**
     * Show error message
     */
    showError(message) {
      logger.error({
        [FIELDS.OPERATION]: 'showError',
        [FIELDS.PAGE_NUMBER]: 2,
        [FIELDS.MESSAGE]: message
      });

      // Could show error in UI or navigate to error page
      // For now, we'll let the widget handle it
      if (this.widget.showPage) {
        this.widget.showPage('fallthrough', { error: message });
      }
    }
}
